import React from "react";
import Modal from "../../elements/Modal";
import MultiselectDropdown from "../../elements/MultiselectDropdown";
import styles from "./index.module.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closePopup } from "../../../store/slices/addReport/popup.slice";
import PulseLoader from "react-spinners/PulseLoader";
import {
  addReport,
  asyncThunkCreateFnbReport,
} from "../../../store/slices/addReport/yourReports.slice";
import { terminalSteps, storeSteps } from "../../../utils/constant";


const AddReportPopup = () => {
  const [selectedTerminal, setSelectedTerminal] = useState([]);
  const [selectedStore, setSelectedStore] = useState([]);
  const [selectedBreakup, setSelectedBreakup] = useState([]);
  const [reportName, setReportName] = useState("");
  const {
    data: { store },
    loading
  } = useSelector((store) => store.fnbConstants);
  const [storeState, setStore] = useState(store);
  const [terminal, setTerminal] = useState(terminalSteps);

  const dispatch = useDispatch();

  // Manage terminal selection.
  const onSelectedTerminalsChange = (value) => {
    setSelectedTerminal(value);
  };

  // Mange store selection.
  const onSelectedStoreChange = (value) => {
    setSelectedStore(value);
  };

  // Manage breakup selection.
  const onSelectedBreakupChange = (value) => {
    setSelectedBreakup(value);
  };

  // Handles title input
  const onChangeTitle = (e) => {
    setReportName(e.target.value);
  };

  // Handle cancel button.
  const showAddReport = () => dispatch(closePopup());

  // Handle create button.
  const onCreate = () => {
    let err = 0;
    if (reportName.length == 0) {
      err++;
      alert("Name field is requied!");
    } else if (selectedTerminal.length == 0) {
      err++;
      alert("Select atleast one terminal!");
    } else if (selectedStore.length == 0) {
      err++;
      alert("Select atleast one store!");
    } else if (selectedBreakup.length < 2) {
      err++;
      alert("Select atleast 2 comparisons!");
    }

    if (err == 0) {
      dispatch(
        asyncThunkCreateFnbReport({
          name: reportName,
          store: selectedStore.join("|").trim(),
          terminal: selectedTerminal.join("|").trim(),
          breakup: selectedBreakup.join("|").trim(),
        })
      );
      // dispatch(
      //   addReport({
      //     title: reportName,
      //     terminal: selectedTerminal,
      //     store: selectedStore,
      //   })
      // );
      showAddReport();
    }
  };

  return (
    <Modal>
      {loading ? (
        <PulseLoader />
      ) : (
        <div className={styles["content"]}>
          {/* Heading */}
          <div className={styles["heading"]}>
            <h3>Create report</h3>
            <p>Create your customized reports</p>
          </div>

          {/* Name input */}
          <div className={styles["nameInput"]}>
            <label htmlFor="">Name</label>
            <input
              type="text"
              placeholder="List of products in Landside"
              value={reportName}
              onChange={onChangeTitle}
            />
          </div>

          {/* Terminal and store */}
          <div className={styles["terminalStore"]}>
            <div className={styles["dropdown"]}>
              <div className={styles["title"]}>
                <span>Terminal</span>
                <i class="bi bi-columns-gap"></i>
              </div>
              <MultiselectDropdown
                steps={terminal}
                name=""
                onChange={onSelectedTerminalsChange}
              />
            </div>
            <div className={styles["dropdown"]}>
              <div className={styles["title"]}>
                <span>Stores</span>
                <i class="bi bi-tag"></i>
              </div>
              <MultiselectDropdown
                steps={storeState}
                name=""
                onChange={onSelectedStoreChange}
              />
            </div>
            <div className={styles["dropdown"]}>
              <div className={styles["title"]}>
                <span>Comparisons</span>
                <i class="bi bi-list"></i>
              </div>
              <MultiselectDropdown
                steps={storeState}
                name=""
                onChange={onSelectedBreakupChange}
              />
            </div>
          </div>
          {/* Create and cancel button */}
          <div className={styles["createCancel"]}>
            <div className={styles["create"]} onClick={onCreate}>
              Create
            </div>
            <div className={styles["cancel"]} onClick={showAddReport}>
              Cancel
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default AddReportPopup;
